import * as Sentry from '@sentry/react';
import { captureClassifiedException } from 'utils/captureClassifiedException';

/** Swallows promise rejections from fire-and-forget async work while reporting to Sentry. */
export const capturePromiseRejection = (promise: Promise<unknown>, context: string): void => {
  promise.catch((error: unknown) => {
    Sentry.addBreadcrumb({
      category: 'async',
      message: context,
      level: 'error',
      data: { error },
    });
    captureClassifiedException(error, { source: 'async', layer: 'action' });
  });
};
